export default __webpack_public_path__ + "static/media/iconReset.ac23fa03.svg";